<template>
  <div id="banner">
    <!-- 导航1 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="./">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>问题反馈管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 主体内容2 -->
    <div class="content">
      <!-- 搜索框sel2.1 -->
      <el-form
        inline
        label-position="right"
        label-width="60px"
        size="small"
        class="query-form"
        @submit.native.prevent="getList()"
      >
        <el-form-item label="搜索">
          <el-input v-model="query.key" placeholder="请输入用户名" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="selClick()">查询</el-button>
        </el-form-item>
      </el-form>
      <!-- 列表框2.2 -->
      <el-card class="box-card table">
        <div slot="header" class="clearfix">
          <span>问题反馈列表</span>
        </div>
        <el-tabs @tab-click="handleClick" v-model="activeName">
          <el-tab-pane label="全部" name="all" ></el-tab-pane>
          <el-tab-pane label="待处理" name="待处理" ></el-tab-pane>
          <el-tab-pane label="已处理" name="已处理" ></el-tab-pane>
          <el-tab-pane label="已取消" name="已取消" ></el-tab-pane>
        </el-tabs>
        <!-- 列表 -->
        <el-table
          v-loading="loading"
          :data="tableData"
          ref="tableData"
          border
          stripe
          style="width:100%"
          @sort-change="sortChange"
          @filter-change="filterTag"
        >
          <el-table-column prop="nickName" label="用户名"></el-table-column>
          <el-table-column prop="mobile" label="手机号"></el-table-column>
          <el-table-column prop="wechat" label="微信号"></el-table-column>
          <el-table-column prop="title" label="反馈标题"></el-table-column>
          <el-table-column prop="content" label="反馈内容"></el-table-column>
          <el-table-column label="反馈图片">
            <template slot-scope="scope">
              <el-tooltip content="图片管理" placement="top">
                  <el-button
                    type="success"
                    size="mini"
                    icon="el-icon-picture"
                    @click="imgClick(scope.row)"
                  ></el-button>
                </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建日期"></el-table-column>
          <el-table-column prop="stateName" label="处理状态"></el-table-column>
          <el-table-column label="操作" v-if="query.state==1||query.state==2">
            <template slot-scope="scope" >
              <el-button-group>
              <el-tooltip content="标记为已处理" placement="top" v-if="query.state==1">
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-star-on"
                  @click="Processed(scope.row)"
                ></el-button>
              </el-tooltip>
              <el-tooltip content="标记为已取消" placement="top" v-if="query.state==1||query.state==2">
                <el-button
                  type="danger"
                  size="mini"
                  icon="el-icon-remove"
                  @click="cancelClick(scope.row)"
                ></el-button>
              </el-tooltip>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页条page -->
        <div class="block" style="margin-top:20px;">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage4"
            :page-size="pageSize"
            :page-sizes="[10,20,30,50,100]"
            layout="total,prev,sizes,pager,next,jumper"
            :total="total"
          ></el-pagination>
        </div>
      </el-card>
    </div>

   <!-- 图片管理 -->
    <el-dialog title="反馈图片管理" :visible.sync="dialogImg">
      <el-row :gutter="20">
        <el-col :span="6" v-for="(item,index) in imgList" :key="item.id">
          <el-card>
            <el-image 
            :src="domain+item" :preview-src-list="[domain+imgList[index]]"
             class="image" style="max-height:200px;max-width:100%;"/>
          </el-card>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";

export default {
  data() {
    return {
      domain: url.getDomain(),
      query: {},
      form: {},
      tableData: [],
      total: 0,
      dialogVisible: false,
      loading: false,
      submiting: false,
      currentPage4: 1,
      pageSize: 10,
      typeSelList:[],
      dialogImg: false,
      imgList:[],
      showImg:false,
      activeName: 'all'
    };
  },
  created() {
    this.getList();
    //this.getBannerType();
  },
  methods: {
    /**获取类型列表 */getBannerType:function(){
      var _this=this;
      var link=url.getSys("getsellist_banner");
      $.get(link,{},res=>{
        _this.typeSelList=res;
      })
    },
    handleSizeChange: function(val) {
      this.pageSize = val;
      this.currentPage4=1;
      this.getList();
    },
    handleCurrentChange: function(val) {
      this.currentPage4 = val;
      this.getList();
    },
    // 排序
    sortChange: function(sortColumn) {
      this.query.sort = sortColumn.sort;
      this.query.order = sortColumn.order;
      this.getList();
    },
    // 筛选
    filterTag: function(filter) {
      var val = filter["isEnable"][0];
      this.getList();
    },
    //查询
    selClick() {
      this.currentPage4 = 1;
      this.getList();
    },
    //列表方法
    getList() {
      var _this = this;
      _this.loading = true;
      var params = _this.query;
      params.pageSize = _this.pageSize;
      params.pageIndex = _this.currentPage4;
      var link = url.getSys("GetList_FeedBack");
      $.get(link, params, data => {
        _this.loading = false;
        _this.tableData = data.list;
        _this.total = data.total;
      });
    },
    // 已处理
    Processed(row) {
      var _this=this;
      var id=row.id;
      var link=url.getSys("Save_FeedBack");
      $.post(link,{id:id,state:2},(res)=>{
         if (res.status) {
              _this.getList();
              this.$message({
                type: "success",
                message: "已标记为已处理!",
              });
            } else {
              this.$message({
                type: "error",
                message: "标记失败!",
              });
            }
      });
    },
    // 已取消
    cancelClick(row) {
      var _this=this;
      var id=row.id;
      var link=url.getSys("Save_FeedBack");
      $.post(link,{id:id,state:3},(res)=>{
         if (res.status) {
              _this.getList();
              this.$message({
                type: "success",
                message: "已标记为已取消!",
              });
            } else {
              this.$message({
                type: "error",
                message: "标记失败!",
              });
            }
      });
    },
    handleClick(tab, event){
      if(tab.index==0){
        this.query.state=null;
        this.getList();
      }else{
        this.query.state=tab.index;
        this.getList();
      }
    },
    //图片管理
    imgClick(row) {
      //获取图片列表
      this.proid = row.id;
      if (row.imgList) {
        this.imgList = row.imgList.split(",");//把一个字符串分割成字符串数组。
      } else {
        this.imgList = [];
      }
      this.dialogImg = true;
    },
  }
};
</script>